module.exports = __webpack_public_path__ + "static/media/big-truck.82b8938c.webp";